var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStorm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71.916px",
    height: "71.916px",
    viewBox: "0 -2.38 71.916 71.916",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lightning",
    transform: "translate(-1270.53 -625.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1321.4,681.3a6.455,6.455,0,0,1-4.566-11.013,6.533,6.533,0,0,1,2.568-1.567l.873-.228,10.238-2.749-2.751,10.227-.27,1.005a6.454,6.454,0,0,1-1.525,2.427,6.376,6.376,0,0,1-4.567,1.9Zm-36.167-2.355a6.442,6.442,0,0,1-2.007-12.572l.873-.227,10.235-2.751-2.757,10.227-.264,1a6.458,6.458,0,0,1-6.08,4.323Z",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1300.5,692.421l2-6.533.7-2.306H1295.7l3.016-9.071h6.668l-2.241,4.036-1.465,2.644h7.115l-8.29,11.229Z",
    fill: "#fdb53f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1329.166,641.692a19.087,19.087,0,0,0-18.667-16.423c-.049,0-.117-.005-.224-.005a19.1,19.1,0,0,0-18.07,12.958,14.778,14.778,0,0,0-10.177,8.649,12.135,12.135,0,0,0-6.006,22.274,9.768,9.768,0,0,1,6.159-5.958l.041-.018.046-.012.959-.251,11.367-3.052a2.853,2.853,0,0,1,.8-.114,2.617,2.617,0,0,1,1.847.741,2.576,2.576,0,0,1,.736,1.853,3.056,3.056,0,0,1-.109.794l-2.16,8.025h16.614a9.569,9.569,0,0,1,2.15-3.239,9.713,9.713,0,0,1,3.871-2.373l.049-.018.04-.016.969-.251,11.363-3.053a3.134,3.134,0,0,1,.806-.1,2.56,2.56,0,0,1,1.843.736,2.62,2.62,0,0,1,.741,1.853,2.987,2.987,0,0,1-.108.8l-1.27,4.721a14.744,14.744,0,0,0-3.612-28.514Z",
    fill: "#f4f4f4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorm);
export default __webpack_public_path__ + "static/media/storm.57b9bc59e68e326dca5dd0626978eaca.svg";
export { ForwardRef as ReactComponent };